export function isPackagingCandidate(product) {
  if (!product || !product.attributes) {
    return false;
  }

  const packagingAttribute = product.attributes.find(
    (attr) => attr.name === 'pa_verpakking',
  );

  return packagingAttribute && packagingAttribute.value === 'Ja';
}

export function getPackagingCandidatesFromSelection(config) {
  if (!config || !config.products) {
    return [];
  }

  return config.products
    ?.filter((p) => typeof p.count === 'number' && p.count > 0)
    ?.filter((product) => isPackagingCandidate(product))
    ?.map((product) => ({
      ...product,
      isPackagingCandidate: true,
    }));
}

export function toPackagingProduct(product) {
  return {
    ...product,
    id: product.id,
    name: product.name,
    price: product.price || 0,
    price_excl_tax: product.price_excl_tax || product.price || 0,
    image: product.image || product.imageUrl || '',
    imageUrl: product.imageUrl || product.image || '',
    taxClass: product.taxClass || 'standard',
    taxRate: product.taxRate || 0.21,
    taxLabel: product.taxLabel || 'BTW-Hoog (21%)',
    attributes: product.attributes || [],
    isPackagingProduct: true,
  };
}

export function packagingToProduct(packaging) {
  return {
    ...packaging,
    isPackagingProduct: null,
  };
}

export function isPackagingModeProduct(config) {
  return config.packagingMode === 'product';
}

export function isPackagingModeBox(config) {
  return config.packagingMode === 'box';
}

export function getPackagingMode(config) {
  return config.packagingMode || 'box';
}

export function getPackagingProduct(config) {
  return config.packagingProduct || null;
}

export function getPackagingBox(config) {
  return config.packaging || null;
}
